export default "__VITE_ASSET__BGsV9EtT__"